// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V31Ostjp3SW0ALRqrOpx {
  height: 100%;
  width: 100%;
  position: relative;
  display: block;
}
.SyC4pfQX6p5mXgZ6leoA {
  font-weight: 800;
  color: #ffdf1a;
  font-size: 22px;
  white-space: nowrap;
}
.SyC4pfQX6p5mXgZ6leoA span {
  font-size: 0.7em;
}
.F2BVPiwdcEDmKKbzcbAh,
.EqeLMYhZ9oybImHXqrKg {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.18px;
}
.EqeLMYhZ9oybImHXqrKg {
  color: #FFDF1A;
}
.hipCYvts9_JCjahNLPmZ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 8px auto;
  height: 41dvh;
  background-color: #1c1c1e;
  border-radius: 8px;
  padding: 1rem;
  max-width: 60%;
}
.mqTMZ1tIMk5bypVnPqn5 {
  color: var(--campaign-color-text-grey);
  font-size: 1.125rem;
  font-weight: 500;
  text-align: center;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .F2BVPiwdcEDmKKbzcbAh,
  .SyC4pfQX6p5mXgZ6leoA,
  .EqeLMYhZ9oybImHXqrKg {
    font-size: 15px;
  }
  .RmZATXB7LhluQzS_zXAB {
    height: 32px !important;
  }
  .hipCYvts9_JCjahNLPmZ {
    max-width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/prizePop/tabs/PrizesTab/PrizesTab.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;;;IAGE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".loaderContainer {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: block;\n}\n.prizeAmountText {\n  font-weight: 800;\n  color: #ffdf1a;\n  font-size: 22px;\n  white-space: nowrap;\n}\n.prizeAmountText span {\n  font-size: 0.7em;\n}\n.remainingCell,\n.totalCell {\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: 0.18px;\n}\n.totalCell {\n  color: #FFDF1A;\n}\n.noDataWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 8px auto;\n  height: 41dvh;\n  background-color: #1c1c1e;\n  border-radius: 8px;\n  padding: 1rem;\n  max-width: 60%;\n}\n.noDataText {\n  color: var(--campaign-color-text-grey);\n  font-size: 1.125rem;\n  font-weight: 500;\n  text-align: center;\n}\n@media (--campaign-mobile) {\n  .remainingCell,\n  .prizeAmountText,\n  .totalCell {\n    font-size: 15px;\n  }\n  .prizesTableRow {\n    height: 32px !important;\n  }\n  .noDataWrapper {\n    max-width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderContainer": `V31Ostjp3SW0ALRqrOpx`,
	"prizeAmountText": `SyC4pfQX6p5mXgZ6leoA`,
	"remainingCell": `F2BVPiwdcEDmKKbzcbAh`,
	"totalCell": `EqeLMYhZ9oybImHXqrKg`,
	"noDataWrapper": `hipCYvts9_JCjahNLPmZ`,
	"noDataText": `mqTMZ1tIMk5bypVnPqn5`,
	"prizesTableRow": `RmZATXB7LhluQzS_zXAB`
};
export default ___CSS_LOADER_EXPORT___;
